import React, {Component} from 'react'
import styles from './InfoListItem.css'
import {TypeListItem} from "../../../constants/consts-prop-types"

function eventSplit(data_list) {
  return data_list && data_list[0] ? data_list[0].split(" ") : undefined;
}

function eventDate(eventDateTimeSplitted) {
  return eventDateTimeSplitted
    ? `${eventDateTimeSplitted[0]} ${eventDateTimeSplitted[1]}`
    : undefined;
}

class InfoListItem extends Component {
  render() {
    const { header_bold, data_list } = this.props.data;
    const { data_list: prevData_list } = this.props.prevItemData || {};

    const eventDateTimeSplitted = eventSplit(data_list);
    const prevEventDateTimeSplitted = eventSplit(prevData_list);

    const date = eventDate(eventDateTimeSplitted);
    const prevDate = eventDate(prevEventDateTimeSplitted);
    const time =
      eventDateTimeSplitted[2] &&
      eventDateTimeSplitted[4] &&
      `${eventDateTimeSplitted[2]} ${eventDateTimeSplitted[3]} ${eventDateTimeSplitted[4]}`;

    return (
      <div ref={(n) => (this.node = n)} className={styles.InfoListItem}>
        {prevDate !== date && <h3 className={styles.date}>{date}</h3>}
        {time && <h4 className={styles.eventTime}>{time}</h4>}
        <h2 className={styles.title}>{`${header_bold}`}</h2>
        {data_list[1] && <h5 className={styles.subtitle}>{data_list[1]}</h5>}
      </div>
    );
  }
}

InfoListItem.propTypes = {
  data: TypeListItem,
  prevItemData: TypeListItem,
};

export default InfoListItem



// WEBPACK FOOTER //
// ./src/components/InfoList/InfoListItem/InfoListItem.js